import { withTranslation } from 'react-i18next';
import ItemFilter from './ItemFilter';

export default withTranslation()(ItemFilter);
